<template>
  <div class="about-us">
    <headline />
    <div class="us">
      <img src="./img/u2835.jpg" alt />
      <p>关于我们</p>
    </div>
    <div class="navigation">
      <ul>
        <li
          :class="navigation[0].display ? 'click-style' : ''"
          @click="cut(0, '#introductionMovement')"
        >
          宥马简介
          <div :class="navigation[0].display ? 'underline' : ''"></div>
          <!-- <img src="./img/point.png" alt /> -->
        </li>
        <li
          :class="navigation[1].display ? 'click-style' : ''"
          @click="cut(1, '#corporateCulture')"
        >
          企业文化
          <div :class="navigation[1].display ? 'underline' : ''"></div>
          <!-- <img src="./img/point.png" alt /> -->
        </li>
        <li
          :class="navigation[2].display ? 'click-style' : ''"
          @click="cut(2, '#qualificationEnterprise')"
        >
          企业资质
          <div :class="navigation[2].display ? 'underline' : ''"></div>
          <!-- <img src="./img/point.png" alt /> -->
        </li>
        <li
          :class="navigation[3].display ? 'click-style' : ''"
          @click="cut(3, '#socialResponsibility')"
        >
          社会体育
          <div :class="navigation[3].display ? 'underline' : ''"></div>
          <!-- <img src="./img/point.png" alt /> -->
        </li>
      </ul>
    </div>
    <div id="introductionMovement" class="synopsis">
      <!-- <div>
        <p class="banner">宥马运动简介</p>
        <p class="subheading">ABOUT US</p>
      </div>-->
      <div>
        <div>
          <div>
            <p class="banner">宥马运动简介</p>
            <p class="subheading">ABOUT US</p>
            <p>
              北京厚德宥马网络科技有限公司成立于2017年,作为体育教学信息化整体解决方案服务商,
              专注于学校体育工作与现代教育技术和互联网、物联网等技术的结合与应用实践探索,打造学校智慧体育管理平台。
            </p>
            <p>
              宥马运动凭借创始人在体育教育行业十余年的耕耘和积累以云计算和大数据等新兴技术为支撑,将行业应用深度融合,
              致力于打造信息时代教学管理与服务新模式,为全国学校的体育信息化提供优质服务。同时,宥马运动期望通过互联网的自由、平等、开拓与创新精神,以开放、互联、共享、协同的平台化理念打造产业链生态体系。
            </p>
          </div>
          <div>
            <p style="visibility:hidden;" class="banner">宥马运动简介</p>
            <p style="visibility:hidden;" class="subheading">ABOUT US</p>
            <img src="./img/u2830.jpg" alt />
          </div>
        </div>
      </div>
    </div>
    <div id="corporateCulture" class="culture">
      <div>
        <p class="banner">企业文化</p>
        <p class="subheading">CORPORATE CULTURE</p>
      </div>
      <div class="culture-background">
        <div>
          <img src="./img/u2878.png" alt />
          <div class="sticker">
            <div>
              <p>企业目标</p>
              <p>Corporation target</p>
            </div>
            <div>
              <p>成为体育教学信息化行业数一数二的公司</p>
            </div>
          </div>
        </div>
        <div>
          <img src="./img/u2920.png" alt />
          <div class="sticker">
            <div>
              <p>愿景</p>
              <p>Vision</p>
            </div>
            <div>
              <p>以软件技术为支点</p>
              <p>推动学校体育工作实现信息化</p>
              <p>为实现中国梦贡献青春的力量</p>
            </div>
          </div>
        </div>
        <div>
          <img src="./img/u2898.png" alt />
          <div class="sticker">
            <div>
              <p>企业价值观</p>
              <p>Corporate values</p>
            </div>
            <div>
              <p>一切以用户为中心。</p>
              <p>着眼创新,注重品质,尊重个人。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="culture-background">
        <div>
          <img src="./img/u2944.png" alt />
          <div class="sticker">
            <div>
              <p>企业作风</p>
              <p>Enterprise style</p>
            </div>
            <div>
              <p>诚实守信,认真负责。</p>
              <p>快速反应,立即行动。</p>
            </div>
          </div>
        </div>
        <div>
          <img src="./img/u2964.png" alt />
          <div class="sticker">
            <div>
              <p>企业精神</p>
              <p>Corprate spirit</p>
            </div>
            <div>
              <p>重大义,勇承担,敢争先,乐奉献。</p>
            </div>
          </div>
        </div>
        <div>
          <img src="./img/u2984.png" alt />
          <div class="sticker">
            <div>
              <p>企业宗旨</p>
              <p>Institution Introduction</p>
            </div>
            <div>
              <p>客户为上,诚信为本。</p>
              <p>明确目标,实现自身价值。</p>
              <p>我们依赖于每一个人,但不依赖于一个人。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="qualificationEnterprise" class="qualifications">
      <div>
        <p class="banner">企业资质</p>
        <p class="subheading">CORPORATE QUALIFICATION</p>
      </div>
      <div class="qualifications-img">
        <div class="first-row">
          <div>
            <div>
              <img class="square" src="./img/u3011.jpg" alt />
            </div>
            <p>软件企业证书</p>
          </div>
          <div>
            <div>
              <img class="square" src="./img/u3015.jpg" alt />
            </div>
            <p>中关村高新技术企业</p>
          </div>
          <div>
            <div>
              <img class="square" src="./img/u3019.jpg" alt />
            </div>
            <p>广播电视节目制作许可证</p>
          </div>
        </div>
        <div class="first-row">
          <div>
            <div>
              <img class="vertical" src="./img/u3027.jpg" alt />
            </div>
            <p>质量管理体系认证证书</p>
          </div>
          <div>
            <div>
              <img class="vertical" src="./img/u3029.jpg" alt />
            </div>
            <p>信息安全管理体系认证证书</p>
          </div>
          <div>
            <div>
              <img class="square" src="./img/u3035.jpg" alt />
            </div>
            <p>信息系统安全等级保护备案证明</p>
          </div>
        </div>
        <div class="third-row">
          <div>
            <div>
              <img class="sliver" src="./img/u3023.jpg" alt />
            </div>
            <p>软件著作权</p>
          </div>
        </div>
      </div>
    </div>
    <div id="socialResponsibility" class="responsibility">
      <div>
        <p class="banner">社会体育</p>
        <p class="subheading">Community sports</p>
      </div>
      <div class="second-row">
        <img src="./img/u3081.jpg" alt />
        <img src="./img/u3083.jpg" alt />
      </div>
      <div class="introduction-sports">
        <p>
          宥马运动作为有高度社会责任感的企业,于2018年5月在成都市民政局正式登记注册成立宥马社会工作服务中心,通过成立专业社会组织,组建跨专业的服务团队（社工团队、视频团队、赛事活动策划团队、新媒体运营团队等）,扎根社区,服务社会。宥马社工致力于探索以社区为中心的城市社区全民健身服务体系建设,以“全民健身促进全民健康”为理念,以社区全民健身服务体系和健康社区服务体系的建设和实践为己任,助力健康社区的构建和发展。
        </p>
      </div>
      <div class="fitness-activities">
        <img src="./img/u3091.jpg" alt />
      </div>
      <div class="introduction-sports">
        <p>
          2020年,在新冠疫情期间,社区防疫工作是疫情防控的重中之重,宥马运动为支持宥马社工更好地开展社区服务工作,根据社区服务项目的需求开发宥马运动小程序,应用于社区线上服务活动的开展。
          将信息化手段与传统社区服务模式相结合,促进社区服务的信息化和现代化发展。
        </p>
      </div>
      <div class="honor">
        <img src="./img/u3085.png" alt />
        <img src="./img/u3087.jpg" alt />
        <img src="./img/u3089.jpg" alt />
      </div>
      <div class="introduction-sports">
        <p>
          宥马运动倡导和支持公司全员参与社区公益服务,在践行社会责任的过程中,投入了大量的专业团队、项目资金和技术支持,自2018年起宥马社工团队对成都30余个社区开展了全民健身服务现状及需求调研,联合成都市近30个社区、专业团体、社会组织和合作单位开展服务项目9个,累计开展各类全民健身服务活动300余次,直接服务6303人次,项目影响82700人次,服务地域涵盖青羊区、金牛区、双流区、高新区、武侯区、锦江区。
        </p>
      </div>
      <div class="introduction-sports">
        <p>
          宥马社工团队的专业服务得到了合作社区、街道和政府部门的认可和支持,也得到了合作伙伴、社区居民的信任和喜爱,宥马运动将长期支持和开展社区服务,积极推动企业责任建设。
        </p>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import headline from "@/components/headline/headline";
import foot from "@/components/foot/foot";

export default {
  data() {
    return {
      navigation: [
        {
          display: true
        },
        {
          display: false
        },
        {
          display: false
        },
        {
          display: false
        }
      ]
    };
  },
  methods: {
    cut(num, name) {
      this.navigation.forEach(element => {
        element.display = false;
      });
      this.navigation[num].display = true;
      console.log(document.querySelector(name));
      document.querySelector(name).scrollIntoView(true);
    }
  },
  components: {
    headline,
    foot
  }
};
</script>

<style lang="less" scoped>
.us {
  position: relative;
  img {
    width: 100%;
    display: block;
  }
  p {
    position: absolute;
    font-size: 1rem;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
  }
}
.navigation {
  height: 1rem;
  background-color: rgba(54, 54, 54, 1);
  text-align: center;
  ul {
    line-height: 1rem;
    height: 100%;
    overflow: hidden;
    li {
      font-size: 0.2rem;
      color: #ffffff;
      font-weight: 600;
      padding: 0 0.4rem;
      cursor: pointer;
      position: relative;
      img {
        position: absolute;
        top: 80%;
        left: 50%;
        transform: translate(-50%, -80%);
      }
    }
  }
}
.click-style {
  background-color: rgba(255, 255, 255, 1);
  color: #1bbc9c !important;
  border-bottom: 0.04rem solid #1bbc9c;
}
.underline {
  width: 100%;
  height: 4px;
  background: #1bbc9c;
  position: absolute;
  left: 0%;
  bottom: 0%;
}
.synopsis {
  background-color: rgba(239, 242, 247, 1);
  padding: 0.8rem 2.55rem;
  & > div:first-child {
    margin-bottom: 0.4rem;
  }
  & > div:last-child {
    & > div {
      display: flex;
      justify-content: center;
      & > div:first-child {
        margin-right: 0.5rem;
      }
      & > div {
        // width: 4.8rem;
        p {
          font-size: 0.2rem;
          font-weight: 600;
          text-indent: 0.4rem;
          color: black;
          line-height: 0.4rem;
          text-align: justify;
          word-break: break-all;
          text-justify: distribute;
        }
        img {
          width: 4.8rem;
          height: 3.2rem;
        }
      }
    }
  }
}
.culture {
  background-image: url(./img/u2833.png);
  background-repeat: round;
  padding: 0.8rem 0;
  & > div:first-child {
    text-align: center;
    margin-bottom: 0.3rem;
  }
  .culture-background {
    position: relative;
    margin: 0 1.5rem;
    display: flex;
    align-content: center;
    justify-content: center;
    & > div {
      flex-wrap: 1;
      width: 3.6rem;
      height: 2.7rem;
      position: relative;
      display: inline-block;
      z-index: 1;
      margin: 0.1rem;
      img {
        width: 100%;
        height: 100%;
      }
      .sticker {
        position: absolute;
        width: 100%;
        height: 0.9rem;
        background-color: #246acb;
        top: 40%;
        transform: translateY(-40%);
        z-index: 2;
        text-align: center;
        & > div:first-child {
          margin: 0.15rem 0;
          & > p:first-child {
            font-weight: 400;
            font-size: 0.2rem;
            color: rgba(255, 255, 255, 1);
          }
          & > p:nth-child(2) {
            font-weight: 400;
            font-size: 0.2rem;
            color: rgba(255, 255, 255, 1);
          }
        }
        & > div:last-child {
          visibility: hidden;
          margin-top: 0.5rem;
          p {
            font-weight: 400;
            font-size: 0.18rem;
            color: #ffffff;
          }
        }
      }
      .sticker:hover {
        height: 100%;
        background-color: rgba(123, 104, 189, 0.7);
        & > div {
          visibility: initial;
        }
      }
    }
  }
}
.qualifications {
  background-color: rgba(239, 242, 247, 1);
  padding: 0.8rem 0;
  & > div:first-child {
    text-align: center;
    margin-bottom: 0.4rem;
  }
  .qualifications-img {
    .first-row {
      width: 100%;
      display: flex;
      justify-content: center;
      & > div {
        text-align: center;
        margin: 0.3rem;
        & > div {
          width: 3.6rem;
          height: 2.7rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .third-row {
      & > div {
        text-align: center;
        & > div {
          width: 9.35rem;
          height: 4.46rem;
          margin: 0.5rem auto 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    p {
      font-weight: 400;
      font-size: 0.2rem;
      color: rgba(34, 34, 34, 1);
      margin-top: 0.2rem;
    }
  }
}
.responsibility {
  background-color: rgba(239, 242, 247, 1);
  padding-bottom: 0.8rem;
  & > div:first-child {
    background-color: rgba(242, 242, 242, 0.6);
    text-align: center;
    margin-bottom: 0.4rem;
  }
  .second-row {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 0.38rem;
    & > img {
      width: 5.5rem;
      height: 3.65rem;
      margin: 0 0.1rem;
    }
  }
  .introduction-sports {
    margin: 0.4rem auto;
    max-width: 11rem;
    p {
      color: #333333;
      font-weight: 400;
      font-size: 0.22rem;
      text-indent: 0.4rem;
      text-align: justify;
    }
  }
  .fitness-activities {
    width: 100%;
    text-align: center;
    img {
      width: 10.99rem;
    }
  }
  .honor {
    width: 100%;
    display: flex;
    justify-content: center;
    img {
      margin: 0 0.1rem;
      height: 3rem;
    }
  }
}
.banner {
  font-size: 0.4rem !important;
  font-weight: 600 !important;
  color: rgba(34, 34, 34, 1) !important;
  margin-bottom: 0.2rem;
}
.subheading {
  font-size: 0.4rem !important;
  font-weight: 500 !important;
  color: rgba(102, 102, 102, 1) !important;
  margin-bottom: 0.2rem;
}
@media screen and (max-width: 900px) {
  .navigation {
    li {
      // font-size: 0.35rem!important;
      img {
        width: 1rem;
      }
    }
  }
  .synopsis {
    padding: 0.4rem 1rem;
    & > div:last-child {
      & > div {
        margin-right: 0.6rem;
      }
      & > img {
        width: 4rem;
      }
    }
  }
}
// @media screen and (max-width: 1440px) {
//   .synopsis {
//     & > div:last-child {
//       & > div {
//         & > div {
//           img {
//             width: 5.4rem !important;
//             height: 3.6rem !important;
//           }
//         }
//       }
//     }
//   }
// }
</style>
